var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "15px",
    viewBox: "0 0 19 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "video icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-media-bar",
    transform: "translate(-42.000000, -9.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.984375,23.515625 C59.546875,23.515625 60.34375,22.7265625 60.34375,21.1796875 L60.34375,12.1640625 C60.34375,10.625 59.546875,9.8359375 57.984375,9.8359375 L45.2421875,9.8359375 C43.6796875,9.8359375 42.8828125,10.6171875 42.8828125,12.1640625 L42.8828125,21.1796875 C42.8828125,22.7265625 43.6796875,23.515625 45.2421875,23.515625 L57.984375,23.515625 Z M57.9375,22.2265625 L45.2890625,22.2265625 C44.5703125,22.2265625 44.171875,21.84375 44.171875,21.09375 L44.171875,12.25 C44.171875,11.5 44.5703125,11.125 45.2890625,11.125 L57.9375,11.125 C58.6484375,11.125 59.0546875,11.5 59.0546875,12.25 L59.0546875,21.09375 C59.0546875,21.84375 58.6484375,22.2265625 57.9375,22.2265625 Z M50.09375,19.390625 L54.0625,17.046875 C54.3515625,16.875 54.3515625,16.4609375 54.0625,16.296875 L50.09375,13.953125 C49.7890625,13.7734375 49.3984375,13.9140625 49.3984375,14.25 L49.3984375,19.09375 C49.3984375,19.4296875 49.7734375,19.5859375 50.09375,19.390625 Z",
    id: "video-icon"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon_video.5210947b.svg";
export { ForwardRef as ReactComponent };